var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDropOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43.1263,
    height: 44,
    rx: 21.5632,
    fill: "#EF7B22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3685 12H24.2043C23.2354 12 22.4465 12.7889 22.4465 13.7578V14.8122H21.5481C21.2244 14.8122 20.9621 15.0746 20.9621 15.3981C20.9621 15.7218 21.2244 15.9841 21.5481 15.9841H22.4592C22.6082 17.6984 24.0476 19.0311 25.7863 19.0311C27.6308 19.0311 29.1263 17.5356 29.1263 15.6911C29.1263 15.0473 29.1263 14.4022 29.1263 13.7578C29.1263 12.7889 28.3375 12 27.3685 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.421 20.4973C23.9934 20.6903 23.6136 20.97 23.3048 21.3135L20.1548 24.5389H15.7578C14.7898 24.5389 14 25.3289 14 26.2969C14 27.2647 14.7899 28.0547 15.7578 28.0547H20.6798C21.2198 28.0547 21.7551 27.919 22.1572 27.5141L22.681 26.9867V31.4138C22.681 31.6976 22.8826 31.946 23.1504 32L28.5412 31.9997C28.8644 31.9994 29.1263 31.7371 29.1263 31.4138V23.5428C29.1263 21.1367 26.627 19.5017 24.421 20.4973Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6104 23.367H19.8293C20.153 23.367 20.4153 23.1047 20.4153 22.7811V18.6014C20.4153 18.2778 20.153 18.0155 19.8293 18.0155H18.3059V19.0219C18.3059 19.3456 18.0434 19.6079 17.7199 19.6079C17.3963 19.6079 17.134 19.3456 17.134 19.0219V18.0155H15.6104C15.2869 18.0155 15.0245 18.2778 15.0245 18.6014V22.7811C15.0245 23.1047 15.2869 23.367 15.6104 23.367Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDropOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drop-off.1659f00c7235e89fef664df53c734a26.svg";